import React from 'react';
import { Container, Card, Text, VStack } from "@chakra-ui/react"

export default function ShippingAndDelivery() {
    return (
        <>
            <Container maxW='8xl' my='6' minH='60vh'>
                <VStack w='100%' spacing='4'>
                    <Card p='5' w='100%'>
                        <Text fontSize='2xl' fontWeight='800' className='customfont'>Shipping and Delivery</Text>
                    </Card>
                    <Card p='5' w='100%'>
                        <VStack w='100%' spacing='4' alignItems='start'>


                            <Text> For Domestic Orders - Within India.</Text>
                            <Text> The dispatch time is 14 - 21 Days.</Text>
                            <Text> Delivery time ranges between 3 - 5 days after dispatch depending on where you are located. This time frame might be affected due to public holidays, natural calamities & other unavoidable circumstances.</Text>

                            <Text>  For International Orders - Outside India.</Text>
                            <Text> The dispatch time is 14 - 21 Days.</Text>
                            <Text>  Delivery time is 5 - 8 business days after dispatch depending on where you are located. This time frame might be affected due to public holidays, natural calamities & other unavoidable circumstances.</Text>

                            <Text>  Any kind of custom charges are to be borne by the recipient, and we are not responsible for any kind of government charges or duties if applicable in your country upon delivery.</Text>

                            <Text>  These timelines for international shipments are estimates and are not guaranteed. If your country charges import fees, it may take longer to receive your package. We strongly recommend international customers to include their phone number at the end of their shipping address.
                                Commercial invoices will be marked as "Merchandise" and the value of the shipment will be marked as equal to the order amount. Shipments cannot be marked as gifts or marked at a price lower than the amount paid.
                                All international orders cannot be exchanged & are non-refundable
                                VAT, GST or any other country duties/taxes/fees are not pre-paid for international orders or included in the shipping cost calculated at checkout and may be levied upon delivery. These additional charges for customs clearance must be fulfilled by the recipient. We have no control over these charges, nor can we predict what they may be.</Text>

                        </VStack>
                    </Card>
                </VStack>
            </Container>
        </>
    )
}
